import { useCallback } from 'react';

import { useAuth } from 'context/auth-context';
import { useLocalization } from 'context/localization-context';
import { AthletePackageAllLimitedCreditsUsed } from 'types';
import {
  buildLastCreditAlert,
  LastCreditAlertAudience,
  LastCreditAlertContent,
} from 'utils/last-credit-alert';

/**
 * Returns a function that turns an all-limited-credits-used result into the last-credit alert
 * for the given audience, dated in the gym's timezone.
 */
export default function useLastCreditAlertBuilder(
  audience: LastCreditAlertAudience,
): (result: AthletePackageAllLimitedCreditsUsed, firstName: string) => LastCreditAlertContent | null {
  const { session } = useAuth();
  const { dateFormat } = useLocalization();
  const timezone = session?.gym?.timezone;

  return useCallback(
    (result, firstName) => buildLastCreditAlert(result, { firstName, audience, timezone, dateFormat }),
    [audience, timezone, dateFormat],
  );
}
